export enum PaymentCurrency {
    inr = "f121554e-7610-4441-9bae-69cd366a4108",
    usd = "a4e3994c-0a7f-4156-abcb-c8e8080750f8",
}
